import moment from "moment"
import { useEffect, useRef, useState } from 'react'

import '../../../styles/reports/reports-common.scss';
import { focusElement, handlekeyDown } from '../../../components/generics/helper';
import BrandAutocomplete from '../../../components/formik-form-components/BrandAutocomplete';
import CategoryAutocomplete from '../../../components/formik-form-components/CategoryAutocomplete';
import DatepickerV2 from '../../../components/shared/DatepickerV2';
import ItemAutocomplete from '../../../components/formik-form-components/ItemAutocomplete';
import RepairReportList from './RepairReportList';
import VendorAutocomplete from "../../../components/formik-form-components/VendorAutocomplete";

const RepairReport = () => {
    const filterInitialValue = { fromDate: moment(new Date()).format("YYYY-MM-DD"), toDate: moment(new Date()).format("YYYY-MM-DD"), searchCategoryIds: '', searchCategoryNames: [], searchSuperCategory: '', searchSubCategoryIds: '', searchSubCategoryNames: [], searchBrandIds: '', searchBrandNames: [], searchItemIds: '', searchItemNames: [], searchVendorIds: '', searchVendorNames: [], showTable: false };
    const [repairReportFilters, setRepairReportFilters] = useState(filterInitialValue);
    const [resetDate, setResetDate] = useState(false);
    const [loadData, setLoadData] = useState(false);

    const vendorFilterRef = useRef(null);
    const categoryFilterRef = useRef(null);
    const subCategoryFilterRef = useRef(null);
    const brandFilterRef = useRef(null);
    const itemFilterRef = useRef(null);

    const repairReportFilterReset = () => {
        setRepairReportFilters({ ...filterInitialValue });
        vendorFilterRef.current.resetAutocomplete();
        categoryFilterRef.current.resetAutocomplete();
        subCategoryFilterRef.current.resetAutocomplete();
        brandFilterRef.current.resetAutocomplete();
        itemFilterRef.current.resetAutocomplete();
        setResetDate(true);
    }

    const generateRepairReport = () => {
        setRepairReportFilters((prev) => ({ ...prev, showTable: true }))
        setLoadData(true);
    }
    useEffect(() => {
        focusElement('fromDate')
    }, [])

    return (
        <>
            <div key="rr_wrapper" className="report--wrapper">
                <div key="rr_filter_wrapper" className="report--filter--wrapper repair--report--filter">
                    <div key="rr_filter_inp_container" className="input--container">
                        <DatepickerV2
                            name={'filter_from_dt'}
                            type="filter_from_dt"
                            className=""
                            star={true}
                            label="From Date"
                            id="fromDate"
                            Reset={resetDate}
                            dateChange={(newValue) => {
                                setResetDate(false);
                                setRepairReportFilters(previousFilters => ({ ...previousFilters, fromDate: moment(newValue).format("YYYY-MM-DD"), showTable: false }));
                                focusElement("toDate")
                            }}
                        />
                    </div>
                    <div key="rr_filter_inp_tod" className="input--container" >
                        <DatepickerV2
                            name={'filter_to_dt'}
                            type="filter_to_dt"
                            className=""
                            star={true}
                            enableFuture={true}
                            emptyField={''}
                            label="To Date"
                            fromDate={repairReportFilters?.fromDate}
                            id="toDate"
                            Reset={resetDate}
                            dateChange={(newValue) => {
                                setResetDate(false);
                                setRepairReportFilters(previousFilters => ({ ...previousFilters, toDate: moment(newValue).format("YYYY-MM-DD"), showTable: false }));
                                focusElement("searchVendorIds")
                            }}
                        />
                    </div>
                    <div className="input--container">
                        <VendorAutocomplete
                            id="searchVendorIds"
                            name="searchVendorIds"
                            label="Vendor Name"
                            searchPlaceholder="Search By Vendor Name"
                            noDataLabel="No Vendor Name Found"
                            isCompulsory={false}
                            singleSelect={false}
                            allOption={false}
                            selectedValues={repairReportFilters.searchVendorIds !== '' ? [repairReportFilters.searchVendorIds] : []}
                            onSelect={(selectedVendors) => {
                                const searchVendorIds = selectedVendors.map((v) => v.vendorId).sort().join(',');
                                const searchVendorNames = selectedVendors.map((v) => v.vendorName).sort();
                                setRepairReportFilters(prev => ({ ...prev, searchVendorIds, searchVendorNames, showTable: false }));
                            }}
                            onRemove={(selectedVendors) => {
                                const searchVendorIds = selectedVendors.map((v) => v.vendorId).sort().join(',');
                                const searchVendorNames = selectedVendors.map((v) => v.vendorName).sort();
                                setRepairReportFilters(prev => ({ ...prev, searchVendorIds, searchVendorNames, showTable: false }));
                            }}
                            ref={vendorFilterRef}
                            nextId="searchCategoryIds"
                            prevId="toDate"
                        />
                    </div>
                    <div key="rr_filter_inp_category" className="input--container">
                        <CategoryAutocomplete
                            id="searchCategoryIds"
                            name="searchCategoryIds"
                            nextId="searchSubCategoryIds"
                            prevId="searchVendorIds"
                            label="Category"
                            isCompulsory={false}
                            singleSelect={false}
                            searchPlaceholder="Search By Category"
                            noDataLabel="No Category Found"
                            categoryFor={1}
                            isParent="Y"
                            selectedValues={repairReportFilters.searchCategoryIds !== '' ? [repairReportFilters.searchCategoryIds] : []}
                            onSelect={(selectedCategory, currentSelection) => {
                                const searchCategoryIds = selectedCategory.map((v) => v.categoryId).sort().join(',');
                                const searchSuperCategory = selectedCategory.length > 0 ? selectedCategory[0].superCategory : '';
                                const searchCategoryNames = selectedCategory.map((c) => c.categoryTitle).sort();
                                setRepairReportFilters(previousFilters => ({ ...previousFilters, searchCategoryIds, searchSuperCategory, searchCategoryNames, showTable: false }));
                            }}
                            onRemove={(selectedCategory, currentSelection) => {
                                const searchCategoryIds = selectedCategory.map((v) => v.categoryId).sort().join(',');
                                const searchSuperCategory = selectedCategory.length > 0 ? selectedCategory[0].superCategory : '';
                                const searchCategoryNames = selectedCategory.map((c) => c.categoryTitle).sort();
                                setRepairReportFilters(previousFilters => ({ ...previousFilters, searchCategoryIds, searchSuperCategory, searchCategoryNames, showTable: false }));
                            }}
                            ref={categoryFilterRef}
                        />
                    </div>
                    <div key="rr_filter_inp_subCategory" className="input--container">
                        <CategoryAutocomplete
                            name="searchSubCategoryIds"
                            nextId="searchBrandIds"
                            prevId="searchCategoryIds"
                            id="searchSubCategoryIds"
                            isCompulsory={false}
                            singleSelect={false}
                            listWidth={400}
                            label="Sub Category"
                            searchPlaceholder="Search By Sub Category"
                            noDataLabel="No Sub Category Found"
                            categoryFor={1}
                            isParent="N"
                            selectedValues={repairReportFilters.searchSubCategoryIds !== '' ? [repairReportFilters.searchSubCategoryIds] : []}
                            onSelect={(selectedSubCategory, currentSelection) => {
                                const searchSubCategoryIds = selectedSubCategory.map((v) => v.categoryId).sort().join(',');
                                const searchSubCategoryNames = selectedSubCategory.map((sc) => sc.categoryTitle).sort();
                                setRepairReportFilters(previousFilters => ({ ...previousFilters, searchSubCategoryIds, searchSubCategoryNames, showTable: false }));
                            }}
                            onRemove={(selectedSubCategory, currentSelection) => {
                                const searchSubCategoryIds = selectedSubCategory.map((v) => v.categoryId).sort().join(',');
                                const searchSubCategoryNames = selectedSubCategory.map((sc) => sc.categoryTitle).sort();
                                setRepairReportFilters(previousFilters => ({ ...previousFilters, searchSubCategoryIds, searchSubCategoryNames, showTable: false }));
                            }}
                            ref={subCategoryFilterRef}
                        />

                    </div>
                    <div key="rr_filter_inp_brand" className="input--container" >
                        <BrandAutocomplete
                            id={'searchBrandIds'} nextId="searchItemIds" prevId="searchSubCategoryIds"
                            name="searchBrandIds"
                            label="Brand"
                            searchPlaceholder="Search By Brand Category"
                            noDataLabel="No Brand Found"
                            isCompulsory={false}
                            singleSelect={false}
                            listWidth={300}
                            selectedValues={repairReportFilters.searchBrandIds !== '' ? [repairReportFilters.searchBrandIds] : ['']}
                            onSelect={(selectedBrands, currentSelection) => {
                                const searchBrandIds = selectedBrands.map((v) => v.brandId).sort().join(',');
                                const searchBrandNames = selectedBrands.map((b) => b.brandName).sort();
                                setRepairReportFilters(previousFilters => ({ ...previousFilters, searchBrandIds, searchBrandNames, showTable: false }));
                            }}
                            onRemove={(selectedBrands, currentSelection) => {
                                const searchBrandIds = selectedBrands.map((v) => v.brandId).sort().join(',');
                                const searchBrandNames = selectedBrands.map((b) => b.brandName).sort();
                                setRepairReportFilters(previousFilters => ({ ...previousFilters, searchBrandIds, searchBrandNames, showTable: false }));
                            }}
                            ref={brandFilterRef}
                        />
                    </div>
                    <div key="rr_filter_inp_item" className="input--container" >
                        <ItemAutocomplete
                            name="searchItemIds"
                            label={"Item Name"}
                            searchPlaceholder={"Search By Item Name"}
                            noDataLabel={"No Item Found"}
                            isCompulsory={false}
                            singleSelect={false}
                            listWidth={450}
                            forAllItems={'Y'}
                            onlyLoginBranchMappedModelsItems={true}
                            selectedValues={repairReportFilters.searchItemIds !== '' ? [repairReportFilters.searchItemIds] : []}
                            onSelect={(selectedItems) => {
                                const searchItemIds = selectedItems.map((i) => i.itemId).sort().join(',');
                                const searchItemNames = selectedItems.map(i => i.itemName);
                                setRepairReportFilters(previousFilters => ({ ...previousFilters, searchItemIds, searchItemNames, showTable: false }));
                            }}
                            onRemove={(selectedItems) => {
                                const searchItemIds = selectedItems.map((i) => i.itemId).sort().join(',');
                                const searchItemNames = selectedItems.map(i => i.itemName);
                                setRepairReportFilters(previousFilters => ({ ...previousFilters, searchItemIds, searchItemNames, showTable: false }));
                            }}
                            ref={itemFilterRef}
                            id="searchItemIds"
                            nextId='generate'
                            prevId='searchBrandIds'
                        />
                    </div>
                    <div className='btn--container'>
                        <div className="dashed--btn" id="generate" tabIndex="0" style={{ marginLeft: '0' }} onClick={() => { generateRepairReport(); }}
                            onKeyDown={(e) => { handlekeyDown(e, `fromDate`, `resetBtn`, `generate`) }}>Generate Report</div>
                        <div key="rr_filter_inp_frd" id="resetBtn" tabIndex="0" className="dashed--btn" onClick={() => repairReportFilterReset()}
                            onKeyDown={(e) => { handlekeyDown(e, `generate`, `fromDate`, `resetBtn`) }}>Reset
                        </div>
                    </div>
                </div>
                <div key="rr_container" className="report--container">
                    {repairReportFilters?.showTable &&
                        <RepairReportList repairReportFilters={repairReportFilters} loadData={loadData} setLoadData={setLoadData} />
                    }
                </div>
            </div>
        </>
    )
}
export default RepairReport;
